import React from "react"
import Img from "gatsby-image"
import { ImgItem } from "./image-item"

const AboutPreShowCalls = ({ image }) => {
  return (
    <ImgItem>
      <div className="textWrapper">
        <h1>Pre-Show Calls</h1>
        <p1>
          Strange show time? Weird panto matinees? Now you can receive
          notifications "x" minutes before each call. It couldn’t be easier.

          Show StopWatch gives you all the relevant calls at the desired times.
          All call times and warning notifications can be customised. Select a
          show time or add a new one, much like you would in Alarms — and
          that’s it!
        </p1>
      </div>

      <Img fluid={image.childImageSharp.fluid} alt="Image" className="image" />
    </ImgItem>
  )
}

export default AboutPreShowCalls
